import { Campaign } from '@/types/campaign.types';

export interface CampaignsState {
  campaigns: Campaign[];
  favoriteTemplates: string[];
  recentTemplates: string[];
  loadingCampaigns: boolean;
  errorLoadingCampaigns: boolean;
  creatingCampaign: boolean;
  errorCreatingCampaign: boolean;
  lastCreatedCampaign: Campaign | null;
  deletingCampaignUuid: string | null;
  errorDeletingCampaign: boolean;
}

export const initialState: CampaignsState = {
  campaigns: [],
  favoriteTemplates: [],
  recentTemplates: [],
  loadingCampaigns: false,
  errorLoadingCampaigns: false,
  creatingCampaign: false,
  errorCreatingCampaign: false,
  lastCreatedCampaign: null,
  deletingCampaignUuid: null,
  errorDeletingCampaign: false,
};
